import { render } from "./Navbar.vue?vue&type=template&id=a6646464&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=a6646464&scoped=true&lang=css"

import exportComponent from "G:\\vue\\lycbuild\\code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6646464"]])

export default __exports__